import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CustomerAccount } from './customer-account.model';
import { customerAccountIdToString, customerAccountSortComparer } from './customer-accounts-entity.util';

import * as ACTIONS from './customer-accounts.actions';

export const CUSTOMER_ACCOUNTS_FEATURE_KEY = 'customerAccounts';

export const customerAccountsAdapter: EntityAdapter<CustomerAccount> = createEntityAdapter<CustomerAccount>({
    selectId: customerAccountIdToString,
    sortComparer: customerAccountSortComparer
});

export interface CustomerAccountsState extends EntityState<CustomerAccount> {
    selectedAccountId: number | string | null;
    loading: boolean;
}

export const CUSTOMER_ACCOUNTS_INITIAL_STATE: CustomerAccountsState = customerAccountsAdapter.getInitialState({
    selectedAccountId: null,
    loading: false
});

export const customerAccountsReducer = createReducer(
    CUSTOMER_ACCOUNTS_INITIAL_STATE,
    on(ACTIONS.fetchCustomerAccounts, (state) => ({ ...state, loading: true })),
    on(ACTIONS.fetchCustomerAccountsSuccess, (state, { accounts }) =>
        customerAccountsAdapter.setAll(accounts, { ...state, loading: false })
    ),
    on(ACTIONS.fetchCustomerAccountsFailed, (state) => ({ ...state, loading: false })),

    on(ACTIONS.selectCustomerAccount, (state, { accountId }) => ({
        ...state,
        selectedAccountId: accountId
    })),

    on(ACTIONS.clearSelectedCustomerAccount, (state) => ({
        ...state,
        selectedAccountId: null
    }))
);
